export * from "./fetch";
import { useAPI } from "../../utils/use-api";
import { Endpoint } from "../common/endpoints";
import { useMutation } from "../../utils/use-mutation";
import { organisationUpdateSelf, organisationRequestPackage, organisationEnforceMfa, organisationAcceptTermsAndConditions, organisationPublicKeyUrl, organisationApproveProposedLink, organisationRejectProposedLink, } from "./fetch";
export const useOrganisationSelf = (organisationId, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.OrganisationSelf,
        endpointParams: { organisationId },
        shouldMakeRequest,
        swrOptions,
    });
};
export const useOrganisationUpdateSelf = (params) => {
    return useMutation(organisationUpdateSelf, params);
};
export const useOrganisationRequestPackage = (organisationId, params) => {
    return useMutation((body, queryParams, headers) => {
        return organisationRequestPackage(organisationId, body, queryParams, headers);
    }, params);
};
export const useOrganisationEnforceMfa = (params) => {
    return useMutation(organisationEnforceMfa, params);
};
export const useOrganisationAcceptTermsAndConditions = (params) => {
    return useMutation(organisationAcceptTermsAndConditions, params);
};
export const useOrganisationPublicKeyUrl = (params) => {
    return useMutation(organisationPublicKeyUrl, params);
};
export const useOrganisationProposedLink = (shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.OrganisationProposedLink,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useOrganisationApproveProposedLink = (params) => {
    return useMutation(organisationApproveProposedLink, params);
};
export const useOrganisationRejectProposedLink = (params) => {
    return useMutation(organisationRejectProposedLink, params);
};
